/* tslint:disable */
/* eslint-disable */
/**
 * Incendium AI API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { ApiDataFromJSON, ApiDataToJSON, } from './ApiData';
import { ApiJobCategoryFromJSON, ApiJobCategoryToJSON, } from './ApiJobCategory';
import { ApiJobTitleFromJSON, ApiJobTitleToJSON, } from './ApiJobTitle';
import { ApiPageFromJSON, ApiPageToJSON, } from './ApiPage';
import { ApiProjectFromJSON, ApiProjectToJSON, } from './ApiProject';
export function ApiJobFromJSON(json) {
    return ApiJobFromJSONTyped(json, false);
}
export function ApiJobFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'category': !exists(json, 'category') ? undefined : json['category'],
        'contractType': !exists(json, 'contractType') ? undefined : json['contractType'],
        'description': !exists(json, 'description') ? undefined : json['description'],
        'id': !exists(json, 'id') ? undefined : json['id'],
        'jobCategory': !exists(json, 'jobCategory') ? undefined : ApiJobCategoryFromJSON(json['jobCategory']),
        'jobCategoryId': !exists(json, 'jobCategoryId') ? undefined : json['jobCategoryId'],
        'jobId': !exists(json, 'jobId') ? undefined : json['jobId'],
        'jobTitle': !exists(json, 'jobTitle') ? undefined : ApiJobTitleFromJSON(json['jobTitle']),
        'jobTitleId': !exists(json, 'jobTitleId') ? undefined : json['jobTitleId'],
        'location': !exists(json, 'location') ? undefined : json['location'],
        'pageViewImpressions': !exists(json, 'pageViewImpressions') ? undefined : (json['pageViewImpressions'].map(ApiDataFromJSON)),
        'pages': !exists(json, 'pages') ? undefined : (json['pages'].map(ApiPageFromJSON)),
        'project': !exists(json, 'project') ? undefined : ApiProjectFromJSON(json['project']),
        'projectId': !exists(json, 'projectId') ? undefined : json['projectId'],
        'salaryRange': !exists(json, 'salaryRange') ? undefined : json['salaryRange'],
        'title': !exists(json, 'title') ? undefined : json['title'],
        'updatedAt': !exists(json, 'updatedAt') ? undefined : (new Date(json['updatedAt'])),
    };
}
export function ApiJobToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'category': value.category,
        'contractType': value.contractType,
        'description': value.description,
        'id': value.id,
        'jobCategory': ApiJobCategoryToJSON(value.jobCategory),
        'jobCategoryId': value.jobCategoryId,
        'jobId': value.jobId,
        'jobTitle': ApiJobTitleToJSON(value.jobTitle),
        'jobTitleId': value.jobTitleId,
        'location': value.location,
        'pageViewImpressions': value.pageViewImpressions === undefined ? undefined : (value.pageViewImpressions.map(ApiDataToJSON)),
        'pages': value.pages === undefined ? undefined : (value.pages.map(ApiPageToJSON)),
        'project': ApiProjectToJSON(value.project),
        'projectId': value.projectId,
        'salaryRange': value.salaryRange,
        'title': value.title,
        'updatedAt': value.updatedAt === undefined ? undefined : (value.updatedAt.toISOString()),
    };
}
